export const TASKS = '/tasks';
export const TASKS_LIST_DAY = '/tasksList/day';
export const TASKS_LIST_WEEK = '/tasksList/week';
export const TASKS_LIST_MONTH = '/tasksList/month';
export const TASKS_LIST_YEAR = '/tasksList/year';
export const TASK = '/tasks/:id';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SIGN_IN_WITH_TOKEN = '/signinWithToken';
export const DELAYED_TASKS = '/delayedTasks';
export const LIST = '/tasksList';
export const CREATE_TASK = '/createTask';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const CHECK_EMAIL = '/check-email';
export const PASSWORD_RESET_CHECK_EMAIL = '/password-reset-check-email';
export const PASSWORD_RESET = '/password-reset';

export const HIDE_NAVIGATION_NO_DESKTOP = ['/tasks/', '/createTask'];

export const IS_DESKTOP = '(min-width: 1280px)';
